<div class="cell-inner" [class.is-blast-date]="isBlastDate()">
  @for (session of sortedSessions(); track session.equipmentId + '_' + session.date + '_' + session.shiftIndex) {
    <div class="block-slot">
      <drill-block
        [session]="session"
        [color]="getColor(session)"
        (blockClick)="sessionClick.emit($event)"
      />
    </div>
  }

  @if (isBlastDate()) {
    <div class="blast-date-dot" aria-label="Blast date" role="img"></div>
  }
</div>
